var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.572 2.834A1.31 1.31 0 0 1 6.85 3.861l.418 1.592h12.595a1.31 1.31 0 0 1 1.284 1.545l-.003.014-1.072 5.228a1.3 1.3 0 0 1-1.289 1.07h-9.91l.392 1.964h7.976a.655.655 0 1 1 0 1.31H9.265a1.31 1.31 0 0 1-1.283-1.048v-.002l-.55-2.745v-.005L6.124 6.255 5.58 4.179l-.008-.035H3.489a.655.655 0 1 1 0-1.31zm13.212 9.167H8.61L7.563 6.763h12.295l-1.071 5.224zm-.888 7.857a1.31 1.31 0 1 0-2.619 0 1.31 1.31 0 0 0 2.62 0Zm-7.858-1.31a1.31 1.31 0 1 1 0 2.62 1.31 1.31 0 0 1 0-2.62",
    clipRule: "evenodd"
  })));
};
export { SvgShoppingCart as ReactComponent };
export default __webpack_public_path__ + "static/media/shoppingCart.74efb71686e9c3ebd701a8cc4303287e.svg";